import { createAction } from '@reduxjs/toolkit'

import { EconomyAccount } from 'types/GlobalEconomySets'

// tryCreateEconomyAccount
export const create = createAction('create_economy_account')
export const createSuccess = createAction<{
  data: EconomyAccount
  economySetId: string
}>('create_economy_account_success')
export const createFailed = createAction('create_economy_account_failed')

// tryUpdateEconomyAccount
export const update = createAction('update_economy_account')
export const updateSuccess = createAction<{
  data: EconomyAccount
  economySetId: string
}>('update_economy_account_success')
export const updateFailed = createAction('update_economy_account_failed')

// tryDeleteEconomyAccount
export const destroy = createAction('destroy_economy_account')
export const destroySuccess = createAction<{
  id: string
  economySetId: string
}>('destroy_economy_account_success')
export const destroyFailed = createAction('destroy_economy_account_failed')
